import React from "react";
import MetaTags from "react-meta-tags";
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";
//Import Images
import { getHomeLink } from "constants/actionAccess";
import error from "../../assets/images/error-img.png";

function clearAllCookies() {
  const cookies = document.cookie.split("; ");
  for (let c = 0; c < cookies.length; c++) {
    const d = window.location.hostname.split(".");
    while (d.length > 0) {
      const cookieBase =
        encodeURIComponent(cookies[c].split(";")[0].split("=")[0]) +
        "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
        d.join(".") +
        " ;path=";
      const p = location.pathname.split("/");
      document.cookie = cookieBase + "/";
      while (p.length > 0) {
        document.cookie = cookieBase + p.join("/");
        p.pop();
      }
      d.shift();
    }
  }
}

const Pages404 = () => {
  const handleClickClearData = () => {
    localStorage.clear();
    sessionStorage.clear();
    clearAllCookies();
    window.location.assign(getHomeLink());
  };

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5">
        <MetaTags>
          <title>404 Error Page</title>
        </MetaTags>
        <Container>
          <Row>
            <Col lg="12">
              <div className="text-center mb-5">
                <h1 className="display-2 font-weight-medium">
                  4<i className="bx bx-buoy bx-spin text-primary display-3" />4
                </h1>
                <h4 className="text-uppercase">Sorry, page not found</h4>
                <div className="mt-5 text-center">
                  <Link className="btn btn-primary " to={getHomeLink()}>
                    Back to Home
                  </Link>
                </div>
                <div className="mt-2">
                  <Button color="danger" onClick={handleClickClearData}>
                    Clear cache data & Back to Home
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8" xl="6">
              <div>
                <img src={error} alt="" className="img-fluid" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Pages404;
